import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLoading } from '../actions/index';
import { updateAdditionalInformation } from '../general-functions';
import LoadingButton from './loading-button';

class FinishButton extends Component {

	handleClick() {
		this.props.setLoading( true );
		updateAdditionalInformation( this.props.userInfo, this.props.token )
			.then( ( response ) => {
				//todo check response here
				window.location.replace( 'update-preferences/thank-you' );

			} );
	}

	render() {
		if ( this.props.isLoading ) {
			return (<div className="button-container"><LoadingButton /></div>
			);
		}
		return (
			<div className="button-container">
				<button class="btn btn-default finish" data-party-id={ getPartyID() } onClick={ this.handleClick.bind( this ) }>Finish</button>
			</div>
		);

	}

}

function mapStateToProps( { userInfo, isLoading, token } ) {
	return {
		userInfo, isLoading, token
	};
}

export default connect( mapStateToProps, { setLoading } )( FinishButton );